import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import FrontPage from './FrontPage';
import ContactMe from './ContactMePage';
import DynamicTTS from './DynamicTTS';
import MusteringPage from './MusteringPage';
import { BrowserRouter, Routes, Route} from 'react-router-dom';
import PageFooter from './PageFooter';
import TopOfPage from './TopOfPage';

function App() {
  return (
    <div className="app-wrapper">
      <BrowserRouter>
      <TopOfPage />
      <div className='content'>
        <Routes>
          <Route path="/" element={<FrontPage />} />
          <Route path="/contact" element={<ContactMe />} />
          <Route path="/DynamicTTS" element={<DynamicTTS />} />
          <Route path="/mustering" element={<MusteringPage />} />
        </Routes>
      </div>
      <PageFooter />
      </BrowserRouter>
    </div>
  );
}

export default App;
